export const SET_APP_VERSION = 'SET_APP_VERSION';

export const setAppVersion = (data) => {
  return {
    type: SET_APP_VERSION,
    payload: data,
  };
};
